import { Input, InputProps } from './Input'

export type NumberInputProps = Omit<InputProps, 'onChange' | 'value'> & {
  onChange?: (value?: number) => void
  value?: number | null
}

export const NumberInput = (props: NumberInputProps) => {
  return (
    <Input
      {...props}
      onChange={(value) => {
        props.onChange?.(value ? Number(value) : undefined)
      }}
      type="number"
      value={props.value === undefined ? undefined : String(props.value)}
    />
  )
}
